import { mapGetters, mapMutations } from 'vuex'
import { GAP_DAY_TYPE } from '@/constants/index.js'
export default {
  data() {
    return {
      optIdx: undefined,
      isShowTimeNodeDialogOfApp: false,
      currentNodeData: []
    }
  },
  computed: {
    ...mapGetters(['getIsApp', 'remindTimeOriginal', 'cancelTimeOriginal'])
  },
  mounted() {
    let _this = this
    window.setRemindRes = (data) => {
      data = JSON.parse(data)
      _this.$toast.clear()
      const { IsError, Msg, ErrMsg } = data
      if (IsError) {
        if (ErrMsg) _this.$toast(ErrMsg)
      } else {
        _this.$toast(Msg)
        this.$EventBus.$emit('updateToSetRemindResEvent')
      }
    }

    this.$EventBus.$on('updateToSetRemindResEvent', () => {
      _this.setRemindResSucessHandler()
    })
  },
  methods: {
    ...mapMutations(['SET_REMIND_TIME_ORIGINAL', 'SET_CANCEL_TIME_ORIGINAL']),
    setRemind({ productId = '', remindTimeOriginal = [], cancelTimeOriginal = [] }) {
      this.$toast.loading({
        message: '设置预约中...',
        forbidClick: true
      })

      this.SET_REMIND_TIME_ORIGINAL(remindTimeOriginal)
      this.SET_CANCEL_TIME_ORIGINAL(cancelTimeOriginal)

      const remindTime = remindTimeOriginal.map(this.modifyTime)
      const cancelTime = cancelTimeOriginal.map(this.modifyTime)

      this.$uni.postMessage({
        data: {
          setRemind: true,
          productId,
          remindTimeStr: remindTime.join(','),
          cancelTimeStr: cancelTime.join(',')
        }
      })
    },
    modifyTime(val) {
      // 获取当前时间
      let today = new Date()
      var tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000)
      // 获取年份
      let todayYear = today.getFullYear()
      let tomorrowYear = tomorrow.getFullYear()
      // 获取月份（注意月份是从0开始计数的，所以需要加1）
      let todayMonth = today.getMonth() + 1
      let tomorrowMonth = tomorrow.getMonth() + 1
      // 获取日期
      let todayDay = today.getDate()
      let tomorrowDay = tomorrow.getDate() + 1
      const todayStr = `${todayYear}-${todayMonth}-${todayDay}`
      const tomorrowStr = `${tomorrowYear}-${tomorrowMonth}-${tomorrowDay}`
      const { GapDay, Node } = val
      if (GapDay === GAP_DAY_TYPE['当天']) {
        return `${todayStr} ${Node}:00`
      } else {
        return `${tomorrowStr} ${Node}:00`
      }
    },
    timeNodeHandler({ productId = '', remindTimeOriginal = [], timeOriginal = [] }) {
      const cancelTimeOriginal = timeOriginal.filter((timeOriginalVal) => {
        return (
          remindTimeOriginal.findIndex((remindTimeOriginalVal) => {
            return JSON.stringify(remindTimeOriginalVal) === JSON.stringify(timeOriginalVal)
          }) < 0 && timeOriginalVal.IsPrePurchase
        )
      })
      this.setRemind({ productId, remindTimeOriginal, cancelTimeOriginal })
    }
  }
}
